// 카드승인 탭 — 업로드 버튼 + 업로드 이력 표. TabCards.jsx 에서 그대로 옮김(2026-11-05, 300줄 규칙, 동작 변화 없음).
import React, { useState } from 'react';
import {
  tblWrap, thStyle, tdStyle,
  btnPrimary, btnSecondary, btnEdit, btnDanger, btnTd, btnGroup,
} from './styles';

export function TabCardsUploadHistory({
  cardBatches,
  fileRef, uploading, handleFileUpload,
  setModal,
  auditTableName = 'revenue_card_approvals', // 변경이력을 볼 기록 이름 (DOT/EXT는 다른 값 전달)
  onDeleteBatch,
  onDownloadBatch,
}) {
  // 업로드 이력 펼침/접힘 — 기본은 최신 1건만 표시
  const [batchExpanded, setBatchExpanded] = useState(false);
  const visibleBatches = batchExpanded ? cardBatches : cardBatches.slice(0, 1);

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-sub)', marginBottom: 6 }}>업로드 이력</div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8, alignItems: 'center' }}>
        <button style={btnPrimary}
          onClick={() => fileRef.current?.click()}
          disabled={uploading}>
          {uploading ? '업로드 중...' : '📤 엑셀/CSV 업로드'}
        </button>
        <input
          ref={fileRef}
          type="file"
          accept=".xlsx,.xls,.csv"
          style={{ display: 'none' }}
          onChange={handleFileUpload}
        />
        <button style={{ ...btnSecondary, marginLeft: 'auto' }}
          onClick={() => setModal({ type: 'auditlog', tableName: auditTableName, title: '카드승인' })}>
          이력
        </button>
      </div>

      {/* 업로드 이력 테이블 — 기본 최신 1건, 펼치면 전체 */}
      {cardBatches.length > 0 && (
        <div style={tblWrap}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['업로드일시','파일명','전체','신규','갱신','스킵','업로더',''].map((h) => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {visibleBatches.map((b) => (
                <tr key={b.id}>
                  <td style={tdStyle}>{b.uploaded_at}</td>
                  <td style={tdStyle}>{b.file_name}</td>
                  <td style={{ ...tdStyle, textAlign: 'center' }}>{b.total_rows}</td>
                  <td style={{ ...tdStyle, textAlign: 'center', color: '#15803d' }}>{b.new_count}</td>
                  <td style={{ ...tdStyle, textAlign: 'center', color: '#0369a1' }}>{b.updated_count}</td>
                  <td style={{ ...tdStyle, textAlign: 'center', color: 'var(--text-muted)' }}>{b.skipped_count}</td>
                  <td style={tdStyle}>{b.uploaded_by_name || '-'}</td>
                  {/* CSV 다운로드 + 삭제 버튼 — 오른쪽 정렬 */}
                  <td style={btnTd}>
                    <div style={btnGroup}>
                      {onDownloadBatch && (
                        <button
                          style={btnEdit}
                          onClick={() => onDownloadBatch(b.id, b.file_name)}>
                          CSV
                        </button>
                      )}
                      {onDeleteBatch && (
                        <button style={btnDanger}
                          onClick={() => onDeleteBatch(b.id)}>
                          삭제
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* 펼치기/접기 버튼 — 이력이 2건 이상일 때만 표시 */}
          {cardBatches.length > 1 && (
            <button
              onClick={() => setBatchExpanded((v) => !v)}
              style={{
                width: '100%', padding: '6px 0', border: 'none',
                background: 'var(--bg-subtle)', color: 'var(--text-muted)',
                fontSize: 11, cursor: 'pointer',
                borderTop: '1px solid var(--border)',
                borderRadius: '0 0 8px 8px',
              }}>
              {batchExpanded
                ? '▲ 접기'
                : `▼ 이전 이력 ${cardBatches.length - 1}건 더 보기`}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
